import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  district: '',
  nutsRegion: '',
  populationRange: { min: 0, max: 1000000 },
  chitalishtaCount: { min: 0, max: 200 },
  sortBy: 'municipality',
  sortDirection: 'asc',
  activeFilters: [],
};

const filterSlice = createSlice({
  name: 'filters',
  initialState,
  reducers: {
    setDistrictFilter: (state, action) => {
      state.district = action.payload;
      state.activeFilters = state.activeFilters.filter(f => f !== 'district');
      if (action.payload) {
        state.activeFilters.push('district');
      }
    },
    setNutsFilter: (state, action) => {
      state.nutsRegion = action.payload;
      state.activeFilters = state.activeFilters.filter(f => f !== 'nuts');
      if (action.payload) {
        state.activeFilters.push('nuts');
      }
    },
    setPopulationFilter: (state, action) => {
      state.populationRange = action.payload;
      state.activeFilters = state.activeFilters.filter(f => f !== 'population');
      if (action.payload.min > 0 || action.payload.max < 1000000) {
        state.activeFilters.push('population');
      }
    },
    setChitalishtaFilter: (state, action) => {
      state.chitalishtaCount = action.payload;
      state.activeFilters = state.activeFilters.filter(f => f !== 'chitalishta');
      if (action.payload.min > 0 || action.payload.max < 200) {
        state.activeFilters.push('chitalishta');
      }
    },
    setSort: (state, action) => {
      state.sortBy = action.payload.field;
      state.sortDirection = action.payload.direction;
    },
    clearAllFilters: (state) => {
      state.district = '';
      state.nutsRegion = '';
      state.populationRange = { min: 0, max: 1000000 };
      state.chitalishtaCount = { min: 0, max: 200 };
      state.activeFilters = [];
    },
    clearFilter: (state, action) => {
      const filterType = action.payload;
      switch (filterType) {
        case 'district':
          state.district = '';
          break;
        case 'nuts':
          state.nutsRegion = '';
          break;
        case 'population':
          state.populationRange = { min: 0, max: 1000000 };
          break;
        case 'chitalishta':
          state.chitalishtaCount = { min: 0, max: 200 };
          break;
      }
      state.activeFilters = state.activeFilters.filter(f => f !== filterType);
    },
  },
});

export const {
  setDistrictFilter,
  setNutsFilter,
  setPopulationFilter,
  setChitalishtaFilter,
  setSort,
  clearAllFilters,
  clearFilter,
} = filterSlice.actions;

export default filterSlice.reducer;